<template>
  <div class="nv-shell">
    <button v-if="menuOpen" class="nv-scrim" aria-label="Close navigation" @click="menuOpen = false"></button>
    <aside class="nv-sidebar" :class="{ 'is-open': menuOpen }">
      <router-link to="/dashboard" class="nv-brand"><img class="nv-brand-image" src="/assets/novus-hosting-logo.png" alt="Novus Hosting"></router-link>
      <div class="nv-workspace"><span class="nv-avatar">{{ initials }}</span><div><strong>{{ user.account || 'Your workspace' }}</strong><small>{{ reseller ? 'Partner workspace' : admin ? 'Provider workspace' : 'Personal workspace' }}</small></div><span class="nv-workspace-dot"></span></div>
      <div class="nv-nav-label">WORKSPACE</div>
      <nav aria-label="Main navigation">
        <router-link v-for="item in navigation" :key="item.path" :to="item.path" :class="{ selected: $route.path === item.path }" @click="menuOpen = false"><span class="nv-nav-icon">{{ item.icon }}</span>{{ item.label }}<span v-if="$route.path === item.path" class="nv-active-dot"></span></router-link>
      </nav>
      <div v-if="reseller" class="nv-partner-note"><span class="nv-kicker">BUILT FOR YOUR BUSINESS</span><h3>Automate your<br>VPS services.</h3><p>Connect your billing platform and make provisioning automatic.</p><router-link to="/integrations">Explore integrations <span>↗</span></router-link></div>
      <div class="nv-sidebar-bottom"><router-link to="/profile">◎ &nbsp; Account & security</router-link><button @click="showAbout = true">Novus Hosting <span>↗</span></button><small>Infrastructure, on your terms.</small></div>
    </aside>
    <div class="nv-main">
      <header class="nv-topbar"><div class="nv-breadcrumb"><button class="nv-menu-toggle" aria-label="Toggle navigation" @click="menuOpen = !menuOpen">☰</button><span>Workspace</span><span class="nv-separator">/</span><strong>{{ title }}</strong></div><div class="nv-topbar-right"><span class="nv-session"><i></i> Session connected</span><router-link to="/activity" aria-label="View activity" class="nv-icon-button">◷</router-link><router-link class="nv-profile-link" to="/profile"><span class="nv-avatar">{{ initials }}</span><span>{{ user.firstname || user.username || 'Account' }}</span></router-link><button class="nv-signout" :disabled="signingOut" @click="signOut">{{ signingOut ? 'Signing out…' : 'Sign out' }}</button></div></header>
      <main class="nv-content"><router-view /></main>
      <footer class="nv-footer"><span>© {{ year }} Novus Hosting</span><span>Designed for what comes next.</span></footer>
    </div>
    <div v-if="showAbout" class="nv-modal-backdrop" @click.self="showAbout = false"><section class="nv-modal" role="dialog" aria-modal="true" aria-labelledby="about-title"><span class="nv-kicker">NOVUS HOSTING</span><h2 id="about-title">A platform built around you.</h2><p>Novus Hosting provides your hosting experience. Infrastructure orchestration uses Apache CloudStack, licensed under the Apache License 2.0.</p><a href="https://www.apache.org/licenses/LICENSE-2.0" target="_blank" rel="noopener">Open-source license ↗</a><div class="nv-modal-actions"><button class="nv-button primary" @click="showAbout = false">Done</button></div></section></div>
  </div>
</template>
<script>
import '@/style/novus.css'
export default {
  name: 'NovusLayout',
  data: () => ({ menuOpen: false, signingOut: false, showAbout: false, year: new Date().getFullYear(), keepAliveTimer: null, isDocumentVisible: true }),
  computed: {
    user () { return this.$store.getters.userInfo || {} },
    reseller () { return this.user.roletype === 'DomainAdmin' },
    admin () { return this.user.roletype === 'Admin' },
    initials () { return ((this.user.firstname || '').slice(0, 1) + (this.user.lastname || '').slice(0, 1)).toUpperCase() || 'N' },
    navigation () {
      const items = [{ path: '/dashboard', label: 'Overview', icon: '◫' }, { path: '/novus-servers', label: 'Instances', icon: '▱' }]
      if (this.reseller || this.admin) items.push({ path: '/novus-customers', label: 'Customers', icon: '♧' })
      items.push({ path: '/activity', label: 'Activity', icon: '◷' })
      if (this.reseller || this.admin) items.push({ path: '/integrations', label: 'Integrations', icon: '⌘' })
      if (this.reseller || this.admin) items.push({ path: '/extensions', label: 'Extensions', icon: '▧' })
      if (this.reseller || this.admin) items.push({ path: '/catalog', label: 'Plans & templates', icon: '▦' })
      if (this.admin) {
        items.push({ path: '/account', label: 'Accounts & users', icon: '♧' })
        items.push({ path: '/domain', label: 'Domains & resellers', icon: '◫' })
        items.push({ path: '/role', label: 'Roles & permissions', icon: '◎' })
        items.push({ path: '/zone', label: 'Infrastructure', icon: '▦' })
      }
      return items
    },
    title () { return this.navigation.find(item => item.path === this.$route.path)?.label || (this.$route.path === '/profile' ? 'Account & security' : 'Workspace') }
  },
  created () {
    this.isDocumentVisible = !document.hidden
    document.addEventListener('visibilitychange', this.handleVisibility)
  },
  mounted () {
    this.keepAliveTimer = setInterval(() => {
      if (!this.isDocumentVisible) {
        return
      }

      this.$store.dispatch('GetInfo')
    }, 10 * 60 * 1000)
  },

  beforeUnmount () {
    document.removeEventListener('visibilitychange', this.handleVisibility)
    if (this.keepAliveTimer) {
      clearInterval(this.keepAliveTimer)
    }
  },

  methods: {
    handleVisibility () {
      this.isDocumentVisible = !document.hidden
    },

    async signOut () {
      this.signingOut = true
      try { await this.$store.dispatch('Logout'); await this.$router.replace('/user/login') } finally { this.signingOut = false }
    }
  }
}
</script>
